import qrCode from 'qrcode';

export default {
  install(vue) {
    // eslint-disable-next-line no-param-reassign
    vue.prototype.$qrCode = qrCode;
  },
};
